export default __webpack_public_path__ + "static/media/powered-by-gametize.99de251d.png";